export class EmailCenterDetailViewModel {
    ShipmentId:number;
    LadingScheduleId:number;
    ComplainId:number;
    IncidentsId:number;
    IsDeliverd:boolean;
    IsReturn:boolean;
}